import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'es',
  months: [
    'enero',
    'febrero',
    'marzo',
    'abril',
    'mayo',
    'junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre',
  ],
  monthsShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
  weekdays: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
  weekdaysMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
  weekdaysShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D [de] MMMM [de] YYYY',
    'LL-D': 'MMMM [de] YYYY',
    'LL-Y': 'D [de] MMMM',
    LLL: 'D [de] MMMM [de] YYYY HH:mm',
    'LLL-Y': 'D [de] MMMM [a las] HH:mm',
    LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
    'LLLL-Y': 'dddd, D [de] MMMM [a las] HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D [de] MMM [de] YYYY',
    'll-Y': 'D [de] MMM',
    lll: 'D [de] MMM [de] YYYY HH:mm',
    'lll-Y': 'D [de] MMM [a las] HH:mm',
    llll: 'ddd, D [de] MMM [de] YYYY HH:mm',
    'llll-Y': 'ddd, D [de] MMM [a las] HH:mm',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'H:mm ([GMT]Z)',
    'LLL+to': 'D [de] MMMM [de] YYYY, H:mm ([GMT]Z)',
  },
  past: {
    y: { one: 'hace %s a', other: 'hace %s a' },
    M: { one: 'hace %s m', other: 'hace %s m' },
    w: { one: 'hace %s sem.', other: 'hace %s sem.' },
    d: { one: 'hace %s d', other: 'hace %s d' },
    h: { one: 'hace %s h', other: 'hace %s h' },
    m: { one: 'hace %s min', other: 'hace %s min' },
    s: { one: 'hace %s s', other: 'hace %s s' },
  },
  future: {
    y: { one: 'dentro de %s a', other: 'dentro de %s a' },
    M: { one: 'dentro de %s m', other: 'dentro de %s m' },
    w: { one: 'dentro de %s sem.', other: 'dentro de %s sem.' },
    d: { one: 'dentro de %s d', other: 'dentro de %s d' },
    h: { one: 'dentro de %s h', other: 'dentro de %s h' },
    m: { one: 'dentro de %s min', other: 'dentro de %s min' },
    s: { one: 'dentro de %s s', other: 'dentro de %s s' },
  },
  abbr: {
    y: { one: '%s año', other: '%s años' },
    M: { one: '%s mes', other: '%s meses' },
    w: { one: '%s semana', other: '%s semanas' },
    d: { one: '%s día', other: '%s días' },
    h: { one: '%s h', other: '%s h' },
    m: { one: '%s min', other: '%s min' },
    s: { one: '%s s', other: '%s s' },
  },
  justNow: 'Justo ahora',
  yesterday: 'Ayer',
  today: 'Hoy',
  tomorrow: 'Mañana',
  weekStart: 1,
};
const localeName: LocaleName = 'es';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (): string => '',
};
